import * as React from "react";
import type { SVGProps } from "react";

interface Minutes2plus2Props extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Minutes2plus2 = ({ cancelled = false, ...props }: Minutes2plus2Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.93} fill="#FFF" rx={8.09} ry={8.14} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.99-.38A1.32 1.32 0 0 1 12.3.8c0 .47-.13.82-.35 1.07-.24.28-.58.44-.96.44l-.38.52a9.88 9.88 0 0 1 8.77 9.74 9.88 9.88 0 0 1-9.88 9.8 9.88 9.88 0 0 1-9.88-9.8A9.88 9.88 0 0 1 8.4 2.83V2.3c-.74 0-1.07-.15-1.31-.39a1.37 1.37 0 0 1 0-1.9c.23-.24.56-.4.93-.4H11ZM9.5 4.97a7.67 7.67 0 0 0-7.66 7.6 7.67 7.67 0 0 0 13.08 5.38 7.55 7.55 0 0 0 0-10.75A7.67 7.67 0 0 0 9.5 4.97Z"
        />
      </g>
      <path
        fill="#FFF"
        d="M3 10h18c.33 1.7.5 2.96.5 3.8s-.17 1.9-.5 3.2H3c-.44-1.54-.66-2.7-.66-3.5s.22-1.96.66-3.5"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M12 11c.26 0 .47.22.47.5v1.53H14c.28 0 .5.21.5.47s-.22.47-.5.47h-1.53v1.53c0 .28-.21.5-.47.5s-.47-.22-.47-.5v-1.53H10c-.28 0-.5-.21-.5-.47s.22-.47.5-.47h1.53V11.5c0-.28.21-.5.47-.5"
      />
      <path
        fill="#FF1212"
        fillRule="nonzero"
        stroke="#FFF"
        d="M18.48 8.53c.55 0 1.04.12 1.48.35q.69.36 1.08 1.05c.25.44.38.98.36 1.63a2.8 2.8 0 0 1-.32 1.26c-.18.35-.42.7-.73 1.03a36 36 0 0 0-1.87 1.93l.08-.09h1.38c.35 0 .62.08.82.21l.1.07c.23.2.37.47.37.87s-.14.68-.38.88c-.2.17-.5.28-.91.28h-3.05c-.37 0-.65-.07-.83-.17-.48-1.15-.4-1.6-.25-2.03.13-.4.35-.83.67-1.27.3-.41.7-.86 1.22-1.35l.66-.68c.2-.2.35-.4.47-.6.15-.6.13-.78.03-.89-.83.45-.96.69-1.11.86-.2.22-.48.36-.9.36-.38 0-.68-.14-.9-.4-.22-.25-.32-.59-.22-1.05a2.72 2.72 0 0 1 2.74-2.25Zm-13 0c.55 0 1.04.12 1.48.35q.69.36 1.08 1.05c.25.44.38.98.36 1.63a2.8 2.8 0 0 1-.32 1.26c-.18.35-.42.7-.73 1.03a36 36 0 0 0-1.87 1.93l.08-.09h1.38c.35 0 .62.08.82.21l.1.07c.23.2.37.47.37.87s-.14.68-.38.88c-.2.17-.5.28-.91.28H3.89c-.37 0-.65-.07-.83-.17-.48-1.15-.4-1.6-.25-2.03.13-.4.35-.83.67-1.27.3-.41.7-.86 1.22-1.35l.66-.68c.2-.2.35-.4.47-.6.15-.6.13-.78.03-.89-.83.45-.96.69-1.11.86-.2.22-.48.36-.9.36-.38 0-.68-.14-.9-.4-.22-.25-.32-.59-.22-1.05a2.72 2.72 0 0 1 2.74-2.25Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Minutes2plus2;
